import { FetchContext } from '../fetch-context';
import { AwardProgramStatistic } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardProgramStatistic: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<AwardProgramStatistic> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/statistic`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardProgramStatistic>(fetchContext.errorStore, response, 'get award program statistic'));
